import { render, staticRenderFns } from "./ConceptsCatalog.vue?vue&type=template&id=24deb53d&scoped=true"
import script from "./ConceptsCatalog.vue?vue&type=script&lang=js"
export * from "./ConceptsCatalog.vue?vue&type=script&lang=js"
import style0 from "./ConceptsCatalog.vue?vue&type=style&index=0&id=24deb53d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24deb53d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/.pnpm/vuetify-loader@1.7.3_uhb5aaqqgawn4pxsnzso5z623i/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
